import { fetchTrainingData } from "../../redux/slice/training"
import { retrunAssets } from "../../utils/getAssets"
import ContainerLayout from "../admission/containerlayout"
import AnimatedPage from "../animatedPage"
import Banner from "../banner/banner"
import EnergySphere from "./rentalFacilities/energySphere"
import FacilitiesAtKSHAS from "./rentalFacilities/facilitiesAtKSHAS"
import FacilitiesAtPutrajaya from "./rentalFacilities/facilitiesAtPutrajaya"
import { useDispatch, useSelector } from 'react-redux';

const RentalFacilities = () => {

    const state = useSelector(state => state.training)
    const dispatch = useDispatch()

    if (state.data == null) {
        dispatch(fetchTrainingData("training-services"))
    }


    const training = state?.data?.properties?.moreInfoButtonPagePath?.properties

    const text = training?.title
    const bg = training?.backgroundImage !== null ? retrunAssets(training?.backgroundImage[0]?.url) : null


    return (
        <AnimatedPage>
            <Banner text={text} bg={bg} />
            <ContainerLayout>
                <div className="grid gap-24 my-16">
                    <FacilitiesAtPutrajaya training={training} />
                    <FacilitiesAtKSHAS training={training}/>
                    <EnergySphere training={training}/>
                </div>
            </ContainerLayout>
        </AnimatedPage>
    )
}

export default RentalFacilities